<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ (data.id ? 'users.userGroups.createEdit.editHeader' : 'users.userGroups.createEdit.createHeader') | translate }}</h3>
    </div>

    <div class="cardContent">
        <form [formGroup]="editUserGroupForm">
            @if (userIsAdmin) {
                <div class="inputGroup">
                    <span class="label">{{ 'users.userGroups.createEdit.companyName' | translate }}</span>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="editUserGroupForm" [controlPath]="'companyName'" />
                        <app-typeahead-select
                            formControlName="companyName"
                            class="formControl"
                            [id]="'companyName'"
                            [optionsList]="suppliers"
                            [idKey]="'id'"
                            [labelKey]="'companyName'"
                        />
                    </div>
                </div>
            }

            @if (isModalReadOnly) {
                <div class="infoNotification">
                    <i class="fa-solid fa-circle-info"></i>
                    <span class="label">{{ 'users.userGroups.createEdit.noFeatureGroups' | translate }}</span>
                </div>
            }

            @if (!isModalReadOnly) {
                <div class="inputGroup">
                    <label for="groupName">{{ 'users.userGroups.createEdit.groupName' | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="editUserGroupForm" [controlPath]="'groupName'" />
                        <input type="text" formControlName="groupName" id="groupName" trimInput />
                    </div>
                </div>
            }

            @if (supplierId && !isModalReadOnly) {
                <div>
                    <app-permissions-control
                        formControlName="permissions"
                        [supplierId]="supplierId"
                        [userGroupId]="data.id"
                        (featureGroupChange)="isModalReadOnly = !($event && $event.length)"
                        [supplierUserOrUserGroupHasAccessToVisualsArea]="userGroupHasAccessToVisualsArea()"
                        [visualPermissions]="visualPermissions()"
                    />
                </div>
            }
        </form>

        <app-loader [type]="'overlayAndSpinner'" [matchAny]="true" />
    </div>

    <app-form-error class="permissionsError" [parentForm]="editUserGroupForm" [controlPath]="'permissions'" />

    <div class="cardFooter">
        <footer class="buttonArea stickyBottom centeredButtons">
            @if (!isModalReadOnly) {
                <button type="submit" class="button primary" (click)="saveUserGroupData()">
                    {{ 'users.userGroups.createEdit.updateUserGroup' | translate }}
                </button>
            }
            <button type="button" class="button" (click)="closeModal(false)">
                {{ 'users.userGroups.createEdit.updateUserGroupCancel' | translate }}
            </button>
        </footer>
    </div>
</div>
